import { render, staticRenderFns } from "./SecondSlider.vue?vue&type=template&id=3150f5aa&scoped=true"
import script from "./SecondSlider.vue?vue&type=script&lang=js"
export * from "./SecondSlider.vue?vue&type=script&lang=js"
import style0 from "./SecondSlider.vue?vue&type=style&index=0&id=3150f5aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3150f5aa",
  null
  
)

export default component.exports